<template>
  <a-modal
    :title="title"
    :width="1380"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="sellContractChange"
              >
                <a-spin v-if="sellContractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProject">
            <a-form-item label="委托方名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ this.selectedProject['host_corporation'] }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedProject">
            <a-form-item label="货物名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ this.selectedProject['category'] }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedSellContract">
            <a-form-item label="HS编码" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ this.selectedSellContract['customs_declaration_code'] }}
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="selectedSellContract">
            <a-form-item label="原产地/货源地" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ this.selectedSellContract['client_country'] }}
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              委托报关信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="进出口类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'import_export_type',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择"
                :default-active-first-option="false"
              >
                <a-select-option v-for="(item, index) in filteredTradeTypes" :key="index" :tt="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="被委托方" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="clientFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'trustee_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入"
                @search="this.clientSearch"
                @change="handleClientChange"
              >
                <a-spin v-if="clientFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in clientList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提单号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['bill_lading_number', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="收费标准" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-textarea v-decorator="['charging_standard', {rules: [{required: false, message: '必填项，请填写信息'}, ]}]" placeholder="请输入" :rows="4"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同附件">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl" />
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import ChooseContractNumberForm from '../../sell_contract/modules/ChooseContractNumberForm'
import { project_client_list } from '@/api/trade_project_client'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { project_list } from '@/api/trade_project'
import { client_list } from '@/api/trade_client'

// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'number', 'name', 'credit', 'cash']
export default {
  components: {
    AttachmentCreateForm,
    ChooseContractNumberForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch2, 800)
    return {
      projectFetching: false,
      clientFetching: false,
      sellContractFetching: false,
      tradeTypeList: this.$Dictionaries.trade_types,
      projectClientList: [],
      clientList: [],
      projectList: [],
      sellContractList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      selectedSellContract: undefined,
      form: this.$form.createForm(this),
      mdl: {},
      otherData: {
        attachment: [],
        guarantee_period_start_date: undefined,
        guarantee_period_end_date: undefined
      },
      visibleFrom: false,
      confirmLoadingFrom: false,
      attachmentColumns: [
        {
          title: '名称',
          width: '100px',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 9 },
          wrapperCol: { span: 15 }
        } : {}
    },
    title () {
      return '新建委托报关'
    },
    filteredTradeTypes () {
      return Object.fromEntries(
        Object.entries(this.tradeTypeList).filter(([k]) => ['2', '3'].includes(k))
      )
    }
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleSellContractSearch (value) {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value !== undefined) {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
        this.handleSellContractSearch()
        this.handleClientSearch(undefined)
      }
    },
    sellContractChange (value) {
      if (value !== undefined) {
        this.selectedSellContract = this.sellContractList.filter(item => item.id === value)[0]
        console.log('购销合同', this.selectedSellContract)
        if (this.selectedSellContract && this.selectedSellContract['client_ids']) {
          console.log('客户列表', this.projectClientList)
          this.selectedSellContract['client_country'] = this.projectClientList.filter(item => this.selectedSellContract['client_ids'].includes(item.client_id)).map(item => this.$Dictionaries.country[item.client_country]).join(',')
        }
      }
    },
    handleClientSearch (value) {
      if (this.selectedProjectId !== undefined && this.selectedProjectId > 0) {
        this.clientSearchData({ name: value, project_id: this.selectedProjectId, page: 1, page_size: 999 }, 1)
      }
    },
    handleClientSearch2 (value) {
      this.clientFetching = true
      client_list({ name: value }).then(res => {
        if (res.code === 1000) {
          this.clientList = res.data.entries || []
        }
      }).finally(() => {
        this.clientFetching = false
      })
    },
    clientSearchData (parameter, type) {
      project_client_list(parameter).then((res) => {
        const result = res.data.entries || []
        if (type === 1) {
          this.projectClientList = result
        } else {
          this.clientList = result
        }
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', this.otherData)
    }
  }
}
</script>
